import { addToast } from "@heroui/toast";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Program, ProgramGroup } from "@/savaradio/common";

export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false,
  convert: false
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>



const initialState: { value?: ProgramGroup[], isLoading: IsLoading } = { isLoading: initialLoading }

const programSlice = createSlice({
  name: "program_slice",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<Program>) => {
      if (!state.value) state.value = [{
        _id: action.payload.day!,
        count: 1,
        programs: [action.payload]
      }]
      else {
        const target_program_group = state.value.find(program_group => program_group._id === action.payload.day)
        if (
          target_program_group &&
          !target_program_group.programs.some(item => item._id === action.payload._id)
        ) {
          state.value = state.value.map(program_group => {
            if (program_group._id === target_program_group._id) return {
              ...target_program_group,
              count: target_program_group.count + 1,
              programs: [...target_program_group.programs, action.payload]
            }
            else return program_group
          })
        }
        if (!target_program_group) {
          state.value = [
            ...state.value,
            {
              _id: action.payload.day!,
              count: 1,
              programs: [action.payload]
            }
          ]
        }
      }
    },
    pop: (state, action: PayloadAction<Program>) => {
      if (state.value) {
        const target_program_group = state.value.find(program_group => program_group._id === action.payload.day)
        if (target_program_group) {
          state.value = state.value.map(program_group => {
            if (program_group._id === target_program_group._id) return {
              ...target_program_group,
              count: target_program_group.count - 1,
              programs: target_program_group.programs.filter(program => program._id !== action.payload._id)
            }
            return program_group
          })
        }
      }
    },
    merge: (state, action: PayloadAction<Program>) => {
      if (state.value) {
        const target_program_group = state.value
          .find(program_group => program_group._id === action.payload.day)
        if (target_program_group) {
          state.value = state.value
            .map(program_group => {
              if (target_program_group._id === program_group._id) {
                if (program_group.programs.some(program => program._id === action.payload._id)) {
                  return {
                    ...program_group,
                    programs: program_group.programs.map(program => (
                      program._id === action.payload._id ?
                        action.payload : program
                    ))
                  }
                }
                return {
                  ...program_group,
                  count: program_group.count + 1,
                  programs: program_group.programs.concat([action.payload])
                }
              }
              else {
                if (program_group.programs.some(program => program._id === action.payload._id))
                  return {
                    ...program_group,
                    programs: program_group.programs
                      .filter(program => program._id !== action.payload._id),
                    count: program_group.count - 1
                  }
                return program_group
              }
            })
            .filter(program_group => program_group.programs.length > 0)
        }
        else {
          state.value = state.value
            .map(program_group => ({
              ...program_group,
              programs: program_group.programs.filter(program => program._id !== action.payload._id),
              count: program_group.count - 1
            }))
            .concat([{
              _id: action.payload.day,
              count: 1,
              programs: [action.payload]
            }])
            .filter(program_group => program_group.programs.length > 0)
        }
      }
      else {
        state.value = [
          {
            _id: action.payload.day,
            count: 1,
            programs: [action.payload]
          }
        ]
      }
    },
    reset: (state, action: PayloadAction<ProgramGroup[] | undefined>) => {
      state.value = action.payload
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading,
        ...action.payload
      }
    }
  }
})

export const { append, pop, merge, reset, setLoading } = programSlice.actions

export const program_slice = programSlice.reducer